import React, { useState } from "react";
import { confirmable } from "react-confirm";
import { Row, Col, Table, Tag } from "antd";
import Modal from "antd/lib/modal/Modal";
import parse from "html-react-parser";
import "./MessageDetailModal.css";

function MessageDetailModal(props) {
  const { show, proceed, subject, content, send_date, attachment, attachmentUrl,
    message_type, recipients, recipients_count } = props;

  const [showRecipients, setShowRecipients] = useState(false);

  const typeLabel = (message_type || "email").toUpperCase() === "SMS" ? "SMS" : "Email";
  const modalTitle = `Campaign (${typeLabel})`;

  const recipientColumns = [
    {
      title: typeLabel === "SMS" ? "Phone Number" : "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const colorMap = { sent: "green", queued: "orange", failed: "red" };
        return <Tag color={colorMap[status] || "default"}>{status || "unknown"}</Tag>;
      },
    },
  ];

  return (
    <Modal
      open={show}
      destroyOnClose={true}
      onCancel={() => { proceed(null); }}
      className="message-detail-dlg"
      closable={true}
      maskClosable={false}
      title={modalTitle}
      okText="Ok"
      onOk={() => { proceed(null); }}
    >
      <Row style={{ marginTop: 20 }} gutter={32}>
        <Col style={{ fontWeight: 600 }}>Subject:</Col>
        <Col>{subject}</Col>
      </Row>
      <Row style={{ marginTop: 10 }} gutter={32}>
        <Col style={{ fontWeight: 600 }}>Send Date:</Col>
        <Col>{send_date}</Col>
      </Row>
      <Row style={{ marginTop: 10 }} gutter={32}>
        <Col style={{ fontWeight: 600 }}>Recipients:</Col>
        <Col>
          <a
            href="#recipients"
            onClick={(e) => {
              e.preventDefault();
              setShowRecipients(!showRecipients);
            }}
            style={{ color: "var(--mainColor)" }}
          >
            {showRecipients ? "Hide" : "View"} {recipients_count || (recipients ? recipients.length : 0)} recipient(s)
          </a>
        </Col>
      </Row>
      {showRecipients && recipients && recipients.length > 0 && (
        <div style={{ marginTop: 10, maxHeight: 250, overflowY: "auto" }}>
          <Table
            columns={recipientColumns}
            dataSource={recipients.map((r, idx) => ({ ...r, key: idx }))}
            pagination={{ pageSize: 10, size: "small" }}
            size="small"
          />
        </div>
      )}
      <div style={{ marginTop: 10 }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>Content</div>
        <div className="editor-rect" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
          {content ? (
            <div style={{ maxWidth: '100%', wordWrap: 'break-word' }}>
              {parse(content)}
            </div>
          ) : (
            <p>No content available</p>
          )}
        </div>
      </div>
      {attachment && attachment !== "" && (
        <div style={{ marginTop: 10 }}>
          <div style={{ fontWeight: 600, marginBottom: 5 }}>Attachment:</div>
          <a
            download={attachment}
            href={attachmentUrl || `#`}
            target={attachmentUrl ? "_blank" : undefined}
            rel={attachmentUrl ? "noopener noreferrer" : undefined}
          >
            {attachment}
          </a>
        </div>
      )}
    </Modal>
  );
}

export default confirmable(MessageDetailModal);
